import { loadObjectFromServer, getData, postData } from "@/utils";

export async function getCompsetLocations(locationId) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const response = await getData(
    `${APP_ROUTES.COMPSET_LOCATIONS}?location_id=${locationId}`
  );
  return response;
}

export async function updateLocationCompset(locationId, payload) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const response = await postData(`${APP_ROUTES.COMPSET_LOCATIONS}`, {
    ...payload,
    location_id: locationId
  });
  return response;
}
